import LastNewsCard from 'components/Pages/Main/LastNews/LastNewsCard/LastNewsCard';
import ErrorState from 'common/ErrorState/ErrorState';
import { useRevealGroup } from 'hooks/useReveal';
import { useContent } from 'hooks/useContent';
import Loader from 'components/Loader/Loader';
import 'components/Pages/News/News.css';
import { useLanguage } from 'hooks/useLanguage';

/**
 * Усі новини — ADR-0006, ADR-0008.
 *
 * Було: лоадер показувався щоразу, коли список порожній, тобто збій запиту
 * виглядав як вічне завантаження. Стало: три різні стани — завантаження,
 * помилка з кнопкою повтору, порожній розділ.
 */
export default function News() {
  const language = useLanguage();
  const { data: articles, status, error, retry, isLoading } = useContent('articles');
  const gridRef = useRevealGroup('.last-news-card', { step: 45 }, status);

  const news = articles
    .filter(({ type }) => type === 'Новина')
    .slice()
    .reverse();

  return (
    <article className='news section'>
      <div className='container'>
        <header className='news-head'>
          <h1 className='page-title'>{language === 'en' ? 'All news' : 'Усі новини'}</h1>
        </header>

        {isLoading && <Loader />}

        {status === 'failed' && <ErrorState error={error} onRetry={retry} />}

        {status === 'succeeded' &&
          (news.length > 0 ? (
            <div className='news-grid' ref={gridRef}>
              {news.map((article) => (
                <LastNewsCard key={article.id} article={article} />
              ))}
            </div>
          ) : (
            <p className='empty-note'>{language === 'en' ? 'There is no news yet.' : 'Новин поки немає.'}</p>
          ))}
      </div>
    </article>
  );
}
